import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StartScreen } from './screens/StartScreen';
import { PaymentDetailsScreen } from './screens/PaymentDetailsScreen';
import { SignatureScreen } from './screens/SignatureScreen';
import { ScheduleInspectionScreen } from './screens/ScheduleInspectionScreen';
import { InspectionConfirmedScreen } from './screens/InspectionConfirmedScreen';
import { MobileFrame } from './components/MobileFrame';
import { useScreenInit } from './useScreenInit.js';
export function App() {
  const screenInit = useScreenInit();
  const [currentStep, setCurrentStep] = useState(screenInit.currentStep ?? 0);
  // currentStep:
  // 0 = Start
  // 1 = Payment details
  // 2 = Payment details + confirmation pop-up
  // 3 = Signature
  // 4 = Schedule inspection (Appointment)
  // 5 = Inspection confirmed
  const screens = [<StartScreen onNext={() => setCurrentStep(1)} data-id="element-0" />, <PaymentDetailsScreen onNext={() => setCurrentStep(2)} onBack={() => setCurrentStep(0)} data-id="element-1" />, <PaymentDetailsScreen onNext={() => setCurrentStep(2)} onBack={() => setCurrentStep(1)} showConfirmation onConfirmationNext={() => setCurrentStep(3)} onConfirmationClose={() => setCurrentStep(1)} data-id="element-2" />, <SignatureScreen onNext={() => setCurrentStep(4)} onBack={() => setCurrentStep(2)} data-id="element-3" />, <ScheduleInspectionScreen onConfirm={() => setCurrentStep(5)} onBack={() => setCurrentStep(3)} data-id="element-4" />, <InspectionConfirmedScreen onFinish={() => setCurrentStep(0)} onBack={() => setCurrentStep(4)} data-id="element-5" />];
  return <div className="w-full min-h-screen bg-gray-100 flex items-center justify-center p-8" data-id="element-6">
      <MobileFrame data-id="element-7">
        <AnimatePresence mode="wait" initial={false} data-id="element-8">
          <motion.div key={currentStep === 2 ? 1 : currentStep} initial={{
          opacity: 0,
          scale: 0.985
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.985
        }} transition={{
          duration: 0.28,
          ease: [0.22, 1, 0.36, 1]
        }} className="h-full" data-id="element-9">
            {screens[currentStep]}
          </motion.div>
        </AnimatePresence>
      </MobileFrame>
    </div>;
}